import { Routes, Route } from 'react-router-dom';
import { AuthGuard } from './components/AuthGuard';
import Home from './pages/Home';
import Join from './pages/Join';
import Room from './pages/Room';
import Register from './pages/Register';
import { ToastContainer } from './components/Toast';

function App() {
  return (
    <div className="min-h-screen bg-page">
      <AuthGuard>
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Home />} />
          <Route path="/join/:roomId?" element={<Join />} />
          <Route path="/room/:roomId" element={<Room />} />
        </Routes>
      </AuthGuard>
      <ToastContainer />
    </div>
  );
}

export default App;
